import { Component, EventEmitter, Output, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'save-before-leaving',
  templateUrl: 'save-before-leaving.component.html',
  styleUrls: ['save-before-leaving.component.scss'],
})
export class SaveBeforeLeavingComponent {

  @Output() action: EventEmitter<string> = new EventEmitter<string>();

  onSaveClick() {
    this._emit('save');
  }

  onDontSaveClick() {
    this._emit('dont_save');
  }

  onCancelClick() {
    this._emit('cancel');
  }

  private _emit(action: string): void {
    this.action.emit(action);
  }

}
